module.exports = __webpack_public_path__ + "static/media/Signup_resize.8dcb066b.jpg";